import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useState } from 'react';
import { AUDITING__VIEW_HISTORY } from 'translations/constants';
import { useTranslation } from 'react-i18next';
import { LogsDialog } from '../audit-logs/LogsDialog';
import { EmployeeLogModalProps } from '../audit-logs/types';

const EmployeeModalMenu = (props: EmployeeLogModalProps): JSX.Element => {
  const { employeeName, employeeId, companyId } = props;
  const [t] = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [logsOpen, setLogsOpen] = useState<boolean>(false);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setLogsOpen(false);
    setAnchorEl(null);
  };

  const handleViewLogs = () => {
    setLogsOpen(true);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleViewLogs}>{t(AUDITING__VIEW_HISTORY)}</MenuItem>
      </Menu>
      <LogsDialog
        open={logsOpen}
        onClose={() => setLogsOpen(false)}
        employeeName={employeeName}
        companyId={companyId}
        employeeId={employeeId}
      />
    </>
  );
};

export default EmployeeModalMenu;
